/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum IssueCreatorType {
    BACKEND_USER = 'BACKEND_USER',
    LAUNDRY_USER = 'LAUNDRY_USER',
    SYSTEM = 'SYSTEM'
}


export function IssueCreatorTypeFromJSON(json: any): IssueCreatorType {
    return IssueCreatorTypeFromJSONTyped(json, false);
}

export function IssueCreatorTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): IssueCreatorType {
    return json as IssueCreatorType;
}

export function IssueCreatorTypeToJSON(value?: IssueCreatorType | null): any {
    return value as any;
}

